
function fabricPopupEvents() {
  // Show popup
  document.querySelectorAll(".fabric-swatch-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".overlay2, .pop_main2").forEach((el) => {
        el.style.display = "block";
        el.style.opacity = "1";
      });
    });
  });

  // Hide popup on overlay click
  document.querySelectorAll(".overlay2, .fabric_closed").forEach((el) => {
    el.addEventListener("click", () => {
      document.querySelectorAll(".overlay2, .pop_main2").forEach((target) => {
        target.style.display = "none";
        target.style.opacity = "0";
      });
    });
  });

  // Optional: set equal height to .fabric_headings if needed (simplified)
  if (document.querySelector(".fabric_headings")) {
    const headings = document.querySelectorAll(".fabric_headings");
    const maxHeight = Math.max(...Array.from(headings).map(h => h.offsetHeight));
    headings.forEach(h => h.style.height = maxHeight + "px");
  }

  // Handle each .fabric_btn
  document.querySelectorAll(".fabric_btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const span = btn.querySelector("span");
      const spinner = btn.querySelector(".loading-overlay__spinner");
      const addedIcon = btn.querySelector(".added_svg");
      const form = btn.closest(".fabric_product_main").querySelector(".fabric_form");

      span.style.display = "none";
      btn.closest(".fabric_product_main").classList.add("active-swatch");
      spinner.classList.remove("hidden");

      const activeSwatches = document.querySelectorAll(".fabric_pooopup .active-swatch");
      if (activeSwatches.length >= 5) {
        document.querySelectorAll(".fabric_btn").forEach(b => b.disabled = true);
        const notify = document.querySelector(".swatch_notify");
        if (notify) notify.style.display = "flex";
      }

      // AJAX request to add to cart
      const formData = new FormData(form);
      formData.append('sections',getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            const err = await response.json();
            throw err;
          } 
          return response.json();
        })
        .then((el) => {
          span.style.display = "inline";
          span.textContent = "Added to cart";
          btn.classList.add("fabric_added");
          btn.disabled = true;
          addedIcon?.classList.remove("hidden");
          spinner.classList.add("hidden");
          for(let key in el.sections) {
            const parser = new DOMParser();
            let doc = parser.parseFromString(el.sections[`${key}`], 'text/html');
            if(key == "cart-drawer") {
              document.querySelector('cart-drawer').classList.remove("is-empty");
              document.querySelector('cart-drawer').renderContents(el);
            }
            else {
              document.querySelector(`#${key}`).innerHTML = doc.body.querySelector(`#shopify-section-${key}`).innerHTML;
            }                      
          }
          
        })
        .catch((errorResponse) => {
          const err = errorResponse;
          const errorBox = document.querySelector(".fabric_product_error");
          if (errorBox) {
            errorBox.style.display = "block";
            errorBox.textContent = err.description || "Error occurred";
          }
          spinner.classList.add("hidden");
          span.style.display = "inline";
          span.textContent = "Maximum limit reached";
          addedIcon?.classList.remove("hidden");
          btn.disabled = true;
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", fabricPopupEvents);

function getSectionsToRender() {
  let sectionsToRender = [
    {
      id: 'cart-icon-bubble'      
    }
  ];
  if(document.querySelector('cart-drawer')) {
    sectionsToRender.push({
      id: 'cart-drawer',
      selector: '#CartDrawer'      
    });
  }
  return sectionsToRender;
}